import React, { ReactNode, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import Tabbar from "src/components/common/Tabbar";

interface IBodyProps {
  children: ReactNode;
  type?: string | undefined;
  isTabbar?: boolean;
}

const Body = (props: IBodyProps) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <BodyWrap type={props.type} className="vmd-contents" isTabbar={props.isTabbar}>
      {props.children}
      {props.isTabbar && isMobile && <Tabbar />}
    </BodyWrap>
  );
};

// Body
// type : main | login | none(pages)
const BodyWrap = styled.main<IBodyProps>`
  ${(props) => {
    switch (props.type) {
      case "main":
        return css`
          padding-top: 60px;
          padding-top: calc(${({ theme }) => theme.mobile.notchHeight}px + 60px);
          padding-bottom: 55px;
          /* padding-bottom: calc(${({ theme }) => theme.mobile.notchHeight}px + 55px); */
        `;
      case "login":
        return css`
          padding-top: 0;
          padding-bottom: 0;
        `;
      case "detail":
        return css`
          ${({ theme }) => theme.flexBox.flexMixin("column", "stretch", "inherit")}
          padding-top: 60px;
          padding-top: calc(${({ theme }) => theme.mobile.notchHeight}px + 60px);
          padding-bottom: 0;
        `;
      case "profile":
        return css`
          padding-top: 0;
          padding-top: calc(${({ theme }) => theme.mobile.notchHeight}px + 0);
          padding-bottom: 70px;
          padding-bottom: calc(${({ theme }) => theme.mobile.notchHeight}px + 70px);
        `;
      default:
        return css`
          padding-top: 60px;
          padding-top: calc(${({ theme }) => theme.mobile.notchHeight}px + 60px);
          padding-bottom: 70px;
          padding-bottom: calc(${({ theme }) => theme.mobile.notchHeight}px + 70px);
        `;
    }
  }}
`;

export default Body;
